import { render } from "./JuryInstructionsReportModal.vue?vue&type=template&id=cbf22e44&scoped=true"
import script from "./JuryInstructionsReportModal.vue?vue&type=script&lang=js"
export * from "./JuryInstructionsReportModal.vue?vue&type=script&lang=js"

import "./JuryInstructionsReportModal.vue?vue&type=style&index=0&id=cbf22e44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf22e44"]])

export default __exports__